import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface CountrySetDefaultParams {
    readonly id: number;
}

export type CountrySetDefaultResponse = {
    value: number,
    version: string
}[];

export class CountrySetDefaultCommand extends Command<CountrySetDefaultParams, CountrySetDefaultResponse> { }

export class CountrySetDefaultCommandHandlerBase implements CommandHandler<CountrySetDefaultCommand, CountrySetDefaultParams, CountrySetDefaultResponse> {
    private static Url = TaggedUrl.join('system/countries/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: CountrySetDefaultCommand): Promise<CountrySetDefaultResponse> {
        const { data } = await this.http.put(fillPlaceholders(CountrySetDefaultCommandHandlerBase.Url, { id: command.params?.id }));

        return data;
    }
}
